import { SiteTypes } from "../graphql"

export const SESSION_TOKEN_KEY = "@LIGHTHOUSE_JMD/SESSION_TOKEN_KEY"
export const SITE_TYPE = process.env.REACT_APP_SITE_TYPE as SiteTypes | undefined
